var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3697 14.3265C32.3697 15.5496 33.3623 16.5412 34.5867 16.5412H45.7829C47.0074 16.5412 48 17.5328 48 18.7559V30.7853C48 32.0084 47.0074 33 45.7829 33H33.2561C32.0316 33 31.039 32.0084 31.039 30.7853V19.6417C31.039 18.4185 30.0464 17.427 28.8219 17.427H19.1781C17.9536 17.427 16.961 18.4185 16.961 19.6417V30.7853C16.961 32.0084 15.9684 33 14.7439 33H2.21707C0.992616 33 0 32.0084 0 30.7853V18.7559C0 17.5328 0.992616 16.5412 2.21707 16.5412H13.1916C14.416 16.5412 15.4086 15.5496 15.4086 14.3265V2.21471C15.4086 0.991558 16.4013 0 17.6257 0H30.1526C31.377 0 32.3697 0.991558 32.3697 2.21471V14.3265Z",
    fill: "#4C56E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f4bc746995743713edc577a287941e1.svg";
export { ForwardRef as ReactComponent };